module.exports = __webpack_public_path__ + "static/harriet-the-spy-ce5c30b191d4ce07f72768ffbc248876.jpg";